import { render } from "./ChallengeView.vue?vue&type=template&id=43811ba0&scoped=true"
import script from "./_ChallengeView.js?vue&type=script&lang=js&external"
export * from "./_ChallengeView.js?vue&type=script&lang=js&external"

import "./_ChallengeView.less?vue&type=style&index=0&id=43811ba0&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43811ba0"]])

export default __exports__